import "@fancyapps/fancybox";
/* eslint-disable */
export default function initFancybox() {
	jQuery("a").each(function (e) {
		if (
			jQuery(this).attr("href") === "#demo-popup" ||
			jQuery(this).attr("href") === "#report-popup-tucson" ||
			jQuery(this).attr("href") === "#report-popup-nobhill" ||
			jQuery(this).attr("href") === "#videos-request-popup" ||
			jQuery(this).attr("href") === "#report-popup-lcrr-compliance"
		) {
			jQuery(this).addClass("lightbox");
		}
	});

	jQuery("a.lightbox, [data-fancybox]").fancybox({
		parentEl: "body",
		margin: [50, 0],
		beforeShow: function () {
			jQuery(".wrapper").addClass("blur");
		},
		afterClose: function () {
			jQuery(".wrapper").removeClass("blur");
			jQuery("#demo-popup .nf-form-layout form").show();
			jQuery("#demo-popup .nf-response-msg").hide();
		},
	});
}



// WEBPACK FOOTER //
// ./assets/scripts/js/_components/fancybox.js